import React from 'react';
import PropTypes from 'prop-types';

import Close from '@zg-rentals/multibrand-ui/lib/icons/Close';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import MultiSelect from '@zg-rentals/multibrand-ui/lib/MultiSelect';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

import cloneDeep from 'lodash/cloneDeep';

const propTypes = {
    title: PropTypes.string,
    value: PropTypes.array,
    handleClose: PropTypes.func,
    isFilterOpen: PropTypes.bool,
    handleChange: PropTypes.func,
};

const defaultProps = {
    title: '',
    value: [],
    handleClose: () => { },
    isFilterOpen: false,
    handleChange: () => { },
};

const MultiSelectFilterPill = ({
    title,
    value,
    handleClose,
    isFilterOpen,
    handleChange,
}) => {
    if (value.length < 1) return null; // Don't display filters for less than 1 value
    let activeLength = 0;
    value.forEach((v) => {
        if (v.isChecked) activeLength += 1;
    });
    if (!isFilterOpen && activeLength === 0) return null;

    const handleClearOptions = () => {
        const newValues = cloneDeep(value);
        newValues.forEach((v) => {
            v.isChecked = false;
        });
        handleClose(newValues);
    };

    if (isFilterOpen) {
        return (
            <Col sm={12} md={6} lg={4}>
                <div className="BillingFilterPill">
                    <MultiSelect
                        label={title}
                        onChange={(i, newValue) => {
                            const newOptions = [
                                ...value.slice(0, i),
                                {
                                    ...value[i],
                                    isChecked: newValue,
                                },
                                ...value.slice(i + 1),
                            ];
                            handleChange(newOptions);
                        }}
                        options={value}
                    />
                </div>
            </Col>
        );
    }
    return (
        <Col sm={6} md={4}>
            <div className="BillingFilterPill">
                <Text className="BillingFilterPill-header">{title}</Text>
                <Text>{`(${activeLength}) selected`}</Text>
                <div className="BillingFilterPill-close" onClick={handleClearOptions}>
                    <Close size={12} />
                </div>
            </div>
        </Col>
    );
};

MultiSelectFilterPill.propTypes = propTypes;
MultiSelectFilterPill.defaultProps = defaultProps;

export default MultiSelectFilterPill;
